import React from 'react';
import { Alert } from 'antd';

export default function FeedbackLabel({
  message,
  errors = {},
  type,
  className = undefined,
  t = undefined,
  transPath = undefined,
}) {
  const _errors = errors ?? {};
  const errorKeys = Object.keys(_errors);

  return (
    <Alert
      type={type}
      title={message}
      description={
        errorKeys.length > 0 ? (
          <ul className="mb-none">
            {errorKeys.map((key, index) => {
              const _transPath = `${transPath ?? 'form'}.${key}.label`;
              const field = t ? t(_transPath, { defaultValue: key }) : key;

              return (
                <li key={`error-${index}`}>
                  {field}: {_errors[key]}
                </li>
              );
            })}
          </ul>
        ) : undefined
      }
      className={className}
      showIcon
    />
  );
}
